module.exports = __webpack_public_path__ + "img/communication.2b4bb19b.svg";